import React from 'react';
import LeadsManagement from './leads-management';

function LeadsDashboard() {
    return (
        <LeadsManagement />
    )
}

export default LeadsDashboard;